"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerColours = exports.IconNameList = exports.BackgroundGreyscaleColours = exports.IconPrimaryColours = exports.IconGreyscaleColours = exports.colourVariantsList = void 0;
exports.colourVariantsList = [
    "green",
    "greyscale",
    "yellow",
    "red",
    "blue",
    "orange",
    "purple",
    "pink",
];
exports.IconGreyscaleColours = [
    "white",
    "night",
    "zinc",
    "stone",
    "silver",
    "metal",
];
exports.IconPrimaryColours = [
    "blue",
    "red",
    "orange",
    "green",
    "purple",
];
exports.BackgroundGreyscaleColours = [
    "white",
    "cloud",
    "dishwater",
    "silver",
    "stone",
    "metal",
    "zinc",
    "night",
];
exports.IconNameList = [
    "AccurxLogo",
    "AddPerson",
    "Arrow",
    "ArrowOneWay",
    "ArrowTail",
    "ArrowTwoWay",
    "Assign",
    "Assigned",
    "Bell",
    "BellMute",
    "Bin",
    "Browser",
    "Calendar",
    "Carehome",
    "Celebrate",
    "Chart",
    "Chat",
    "Clock",
    "Cog",
    "Collapse",
    "ColumnThree",
    "ColumnTwo",
    "Copy",
    "Cross",
    "Dashboard",
    "Doctor",
    "Document",
    "Done",
    "Dot",
    "Error",
    "Expand",
    "Failed",
    "Filter",
    "Flag",
    "Hashtag",
    "HealthProfessional",
    "Hospital",
    "IdCard",
    "Inbox",
    "Info",
    "Link",
    "List",
    "Location",
    "LockAllowed",
    "LockDenied",
    "LockLocked",
    "LockUnlocked",
    "Mail",
    "Mailbox",
    "Medication",
    "Mention",
    "Menu",
    "Message",
    "Messages",
    "MessageWrite",
    "Minimise",
    "Minus",
    "More",
    "NoPerson",
    "Off",
    "On",
    "OpenWindow",
    "SortUp",
    "SortDown",
    "Paperclip",
    "Pencil",
    "PenToSquare",
    "Person",
    "Phone",
    "Photo",
    "Pin",
    "Plus",
    "Question",
    "Questionnaire",
    "Record",
    "RecordPerson",
    "Refresh",
    "Reply",
    "ReviewPerson",
    "Save",
    "Search",
    "SearchPerson",
    "Send",
    "Slide",
    "Star",
    "Success",
    "Survey",
    "Syringe",
    "Tag",
    "Team",
    "Tick",
    "TickDouble",
    "Unassigned",
    "Unread",
    "Upload",
    "Video",
    "Warning",
    "Window",
    // Preview icons
    "preview-Account",
    "preview-Logout",
    "preview-Swap",
    "preview-Triage",
    "preview-Message",
    "preview-MessageHealthProfessional",
    "preview-PatientList",
    "preview-Directory",
];
exports.SpinnerColours = ["blue", "white"];
//# sourceMappingURL=types.js.map